var map = {
	"./de/general6/slide1.svg": 161131,
	"./en/general6/slide1.svg": 830863,
	"./es/general6/slide1.svg": 473938,
	"./fr/general6/slide1.svg": 351626,
	"./nl/general6/slide1.svg": 143656,
	"./pt/general6/slide1.svg": 377358
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 79141;